import { gql } from "@apollo/client";
import { Text } from "@mantine/core";
import { useParams } from "react-router-dom";
import { AutoDataTable } from "../../../components/AutoDataTable";
import { ListPageHeader } from "../../../components/PageHeader";

const PURCHASE_HISTORY_QUERY = gql`
  query ($cursor: String, $count: Float, $shopIds: [ID!]) {
    playerShopProductPurshases(
      filter: { shopIds: $shopIds }
      page: { first: $count, after: $cursor }
    ) {
      nodes {
        id
        playerProfileId
        shopProductId
        quantity
        createdAt
      }
      totalCount
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`;

export function PurchaseHistory() {
  const { shopId } = useParams<{ shopId: string }>();

  if (!shopId) {
    return null;
  }

  return (
    <div className="wp-fade-in">
      <ListPageHeader
        title="Purchase History"
        subtitle="View all purchases made in this shop"
        showBreadcrumbs={false}
      />

      <AutoDataTable
        itemPath="../purchases"
        createButtonText={false}
        query={PURCHASE_HISTORY_QUERY}
        queryVariables={{ shopIds: [shopId] }}
        columns={[
          {
            accessor: "playerProfileId",
            title: "Player Profile ID",
          },
          {
            accessor: "shopProductId",
            title: "Product ID",
          },
          {
            accessor: "quantity",
            title: "Quantity",
          },
          {
            accessor: "createdAt",
            title: "Date",
            rawElement: (record: any) => (
              <Text size="sm">
                {record.createdAt
                  ? new Date(record.createdAt).toLocaleString()
                  : "-"}
              </Text>
            ),
          },
        ]}
      />
    </div>
  );
}
